import { LEGAL } from './legal';

/**
 * Where people can get the mobile apps.
 *
 * Neither app has a public store listing yet: iOS is in TestFlight and Android is in
 * Play internal testing, both invite-only. Leave a URL empty until the listing is
 * public — the site then shows "coming soon" and a way to ask to join the beta
 * instead of a button that goes nowhere.
 */
export const STORES = {
  /** Public App Store URL, e.g. https://apps.apple.com/app/id0000000000. */
  iosUrl: '',
  /** Public Google Play URL, e.g. https://play.google.com/store/apps/details?id=com.pintumo.cares. */
  androidUrl: '',
  /** Where beta requests go while the apps are invite-only. */
  betaEmail: LEGAL.supportEmail,
} as const;
